import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UpdateDepositModalUI from './UpdateDepositModalUI.js'

class UpdateDepositModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      dsraFromLoan: this.props.loan.termSheet.dsraFromLoan ? 'true' : 'false',
      dsraError: null,
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <UpdateDepositModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        dsraFromLoan={this.state.dsraFromLoan}
        onDsraChange={(event) => { this.setState({ dsraFromLoan: event.target.value }) }}
        dsraError={this.state.dsraError}
        booleanList={booleanList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  /*
  componentDidUpdate(prevProps) {
    if (this.props.loan.termSheet.dsraFromLoan === prevProps.loan.termSheet.dsraFromLoan &&
        this.props.loan.termSheet.processingFeeFromLoan === prevProps.loan.termSheet.processingFeeFromLoan)
      return

    this.setState({
      dsraFromLoan: this.props.loan.termSheet.dsraFromLoan ? 'true' : 'false',
      processingFeeFromLoan: this.props.loan.termSheet.processingFeeFromLoan ? 'true' : 'false'
    })
  }
  */

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/dsraSource`,
      this.onSubmitCallback,
      {
        dsraFromLoan: this.state.dsraFromLoan,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(UpdateDepositModalSF)
